<ng-container *ngIf="user_service.show_verification_banner()">
  <div class="alert alert-warning verification-alert">
    <a class="pull-right" (click)="close_banner()"><span class="fa fa-times"></span></a>
    <a routerLink="/verify-patient" (click)="close_banner()">
      Your {{getMessage()}} is not verified. Please click here to verify
    </a>
  </div>
</ng-container>
